import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import { CategoryMetas } from "@hermes/api-model-category";
import { LOCALE, Settings } from "@hermes/app-core";
import { Locale } from "@hermes/locale";

@Injectable()
export class CategoryService {
    private locale = inject(LOCALE);
    private http = inject(HttpClient);
    private settings = inject(Settings);

    public getCategory(categoryPimCode: string): Observable<CategoryMetas> {
        return this.http.get<CategoryMetas>(
            `${this.settings.apiUrl}/category/${encodeURIComponent(
                categoryPimCode,
            )}`,
        );
    }
}
